export const selectCurrentOrder = (state) => {
    return state.currentOrder;
}
